import React from 'react';
const valueBreakdown = [{
  label: 'Percorso Didattico (6 Volumi 1ª–5ª)',
  value: '€97'
}, {
  label: 'Verifiche editabili & Rubriche',
  value: '€57'
}, {
  label: 'Esperimenti Laboratorio Impossibile',
  value: '€47'
}, {
  label: '6 Bonus Esclusivi',
  value: '€49'
}];
const trustBadges = [{
  icon: '🔒',
  title: 'Pagamento Sicuro',
  sub: 'Crittografia SSL 256-bit'
}, {
  icon: '🛡️',
  title: 'Garanzia 7 Giorni',
  sub: 'Soddisfatti o rimborsati'
}, {
  icon: '✅',
  title: 'Acquisto Verificato',
  sub: '+1.500 docenti soddisfatti'
}];
const paymentMethods = ['VISA', 'Mastercard', 'AMEX', 'Apple Pay', 'Google Pay'];
const CHECKOUT_URL = 'https://italia.edulabs.online/cart/43454242029686:1';
const PRICE = 19;
export function PricingSection() {
  return <section id="pricing" aria-label="Prezzi e offerte" className="bg-brand-dark py-8 md:py-28 px-4 border-t border-brand-border" data-id="element-187">
      <div className="max-w-xl mx-auto" data-id="element-188">
        {/* Title */}
        <div className="text-center mb-4 md:mb-10" data-id="element-189">
          <h2 className="text-2xl md:text-5xl font-heading font-black text-white leading-tight" data-id="element-190">
            L'Offerta <span className="text-brand-accent" data-id="element-191">"Fisica Pronta"</span>
          </h2>
        </div>

        {/* Main Offer Card */}
        <div className="relative bg-brand-card border border-brand-border rounded-2xl md:rounded-3xl p-4 md:p-8 shadow-[0_0_40px_rgba(0,255,133,0.08)]" data-id="element-192">
          {/* Popular Badge */}
          <div className="flex justify-center -mt-9 md:-mt-12 mb-3 md:mb-6" data-id="element-193">
            <div className="bg-brand-accent text-brand-dark font-black text-[10px] md:text-sm uppercase tracking-widest px-4 md:px-5 py-1.5 md:py-2 rounded-full shadow-lg flex items-center gap-2" data-id="element-194">
              ⭐ LA SCELTA PIÙ POPOLARE
            </div>
          </div>

          {/* Value Breakdown */}
          <div className="mb-2" data-id="element-195">
            <h3 className="text-xs md:text-lg font-heading font-black text-white uppercase tracking-wider mb-2.5 md:mb-5" data-id="element-196">
              VALORE TOTALE DEI CONTENUTI:
            </h3>
            <div className="space-y-1.5 md:space-y-3.5" data-id="element-197">
              {valueBreakdown.map((item, i) => <div key={i} className="flex items-center justify-between text-xs md:text-base" data-id="element-198">
                  <span className="text-white/80" data-id="element-199">{item.label}</span>
                  <span className="text-white/40 line-through font-medium whitespace-nowrap pl-3" data-id="element-200">
                    {item.value}
                  </span>
                </div>)}
              <div className="border-t border-brand-border pt-2 md:pt-4 mt-2 flex items-center justify-between" data-id="element-201">
                <span className="text-white font-heading font-black uppercase tracking-wider text-xs md:text-lg" data-id="element-202">
                  Valore Reale:
                </span>
                <span className="text-[#FF4D33] line-through font-heading font-black text-base md:text-2xl" data-id="element-203">
                  € 250
                </span>
              </div>
            </div>
          </div>

          {/* Big Price Box */}
          <div id="price-box" className="mt-3 md:mt-6 mb-4 md:mb-6 bg-brand-dark border border-brand-border rounded-xl md:rounded-2xl p-4 md:p-8 text-center scroll-mt-24" data-id="element-204">
            <div className="flex items-center justify-center gap-2 md:gap-3 mb-1 md:mb-3" data-id="element-205">
              <span className="text-white/40 line-through font-medium text-xs md:text-lg" data-id="element-206">
                € 250
              </span>
              <span className="bg-brand-accent/20 text-brand-accent font-black text-[9px] md:text-xs px-2 md:px-2.5 py-0.5 md:py-1 rounded-full uppercase tracking-wider" data-id="element-207">
                92% OFF
              </span>
            </div>
            <div className="text-brand-accent font-heading font-black text-5xl md:text-7xl leading-none mb-2 md:mb-3 tracking-tight" data-id="element-208">
              € {PRICE}
            </div>
            <div className="text-white/70 text-[10px] md:text-sm font-medium flex flex-wrap items-center justify-center gap-x-2 md:gap-x-3 gap-y-1" data-id="element-209">
              <span data-id="element-210">💳 Pagamento unico</span>
              <span className="text-white/30" data-id="element-211">•</span>
              <span data-id="element-212">⚡ Accesso immediato</span>
            </div>
          </div>

          {/* Urgency Pill */}
          <div className="flex justify-center mb-4 md:mb-6" data-id="element-213">
            <div className="bg-brand-accent/10 border border-brand-accent/30 text-brand-accent text-[10px] md:text-sm font-bold px-3 md:px-4 py-1.5 md:py-2 rounded-full flex items-center gap-2" data-id="element-214">
              <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-brand-accent animate-pulse" data-id="element-215" />
              Prezzo speciale di lancio — salirà a breve
            </div>
          </div>

          {/* Main CTA */}
          <button onClick={() => window.open(CHECKOUT_URL, '_blank')} aria-label={`Acquista per €${PRICE}`} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black text-base md:text-2xl py-5 md:py-7 rounded-xl md:rounded-2xl transition-all flex items-center justify-center gap-2 active:scale-[0.98] shadow-[0_8px_30px_rgba(0,255,133,0.25)]" data-id="element-216">
            🚀 SÌ! VOGLIO FISICA PRONTA — € {PRICE}
          </button>

          {/* Trust Badges Grid */}
          <div className="grid grid-cols-3 gap-2 md:gap-3 mt-5 md:mt-6" data-id="element-217">
            {trustBadges.map((badge, i) => <div key={i} className="bg-brand-dark border border-brand-border rounded-lg md:rounded-xl p-2.5 md:p-4 text-center" data-id="element-218">
                <div className="text-lg md:text-2xl mb-0.5 md:mb-1" data-id="element-219">
                  {badge.icon}
                </div>
                <div className="text-white font-bold text-[10px] md:text-xs leading-tight mb-0.5" data-id="element-220">
                  {badge.title}
                </div>
                <div className="text-white/60 text-[9px] md:text-[10px] leading-tight" data-id="element-221">
                  {badge.sub}
                </div>
              </div>)}
          </div>

          {/* Payment Methods */}
          <div className="mt-5 md:mt-6 pt-4 md:pt-5 border-t border-brand-border" data-id="element-222">
            <p className="text-[9px] md:text-xs font-bold text-white/50 uppercase tracking-widest text-center mb-2.5 md:mb-3" data-id="element-223">
              Pagamenti accettati
            </p>
            <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2" data-id="element-224">
              {paymentMethods.map((method, i) => <span key={i} className="bg-white text-brand-dark font-black text-[9px] md:text-xs px-2 md:px-2.5 py-1 md:py-1.5 rounded-md tracking-tight" data-id="element-225">
                  {method}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}